import PropTypes from 'prop-types'

const { shape, string, array, any } = PropTypes


export const itemType = shape({
  id: string,
  title: string,
  subTitle: string,
  fullAncestors: array,
  childItems: any
})

export const s3fileType = shape({
  Key: string,
  LastModified: any,
  ETag: string,
  Size: any,
  StorageClass: string
})
